<div class="bg-surface-0 dark:bg-surface-900 border border-surface rounded-border">
  <router-outlet />
</div>
